// extracted by mini-css-extract-plugin
export default {"graphVizPane":"GraphVizPanel_graphVizPane__4J1y+"};